import './Footer.scss';
import { useState, useEffect } from 'react';

export default function Footer() {
  const [currentYear, setCurrentYear] = useState(2000);

  useEffect(() => {
    const currentDate = new Date();
    setCurrentYear(currentDate.getUTCFullYear());
  }, []);

  return (
    <div className="app-footer-wrapper">
      <div className="footer-content">
        <a
          className="link"
          href="/about"
          target="_blank"
          rel="noopener noreferrer"
        >
          Kontakta oss
        </a>
        <p className="trademark">© {currentYear} All rights reserved</p>
        <p
          className="trademark"
          style={{ textAlign: 'right', maxWidth: '400px', marginLeft: 'auto' }}
        >
          Webbplatsen, xpektor.se, tillhandhålls av Xpektor Tech AB och har
          utgivningsbevis nr 2025-003, ansvarig utgivare är Daniel Eremar.
        </p>
      </div>
    </div>
  );
}
